var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94761 15.6743L0.24346 8.54307C-0.0811533 8.24288 -0.0811533 7.7579 0.24346 7.45693L7.94761 0.325723C8.41622 -0.108574 9.17865 -0.108574 9.64809 0.325723C10.1167 0.76002 10.1167 1.46488 9.64809 1.89917L3.05761 8.00039L9.64809 14.1C10.1167 14.5351 10.1167 15.24 9.64809 15.6743C9.17865 16.1086 8.41622 16.1086 7.94761 15.6743Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.3466b4cf.svg";
export { ForwardRef as ReactComponent };